export default "__VITE_ASSET__8f219b73__"